<template>
    <b-overlay :show="loading">
        <PillFilterControl v-model="selected" :options="options" />
        <WorldRecordsTable :items="filteredRecords" />
    </b-overlay>
</template>

<script>
import { fetchMappedRecords } from '@/data/world_records';
import { singleTagFilter } from '@/common/tagFiltering';
import PillFilterControl from '@/components/common/PillFilterControl.vue';
import WorldRecordsTable from './WorldRecordsTable.vue';

export default {
    data() {
        return {
            options: [{
                description: "All",
                code: "all"
            }, {
                description: "3-3-3",
                code: "333"
            }, {
                description: "3-6-3",
                code: "363"
            }, {
                description: "Cycle",
                code: "cycle"
            }, {
                description: "Doubles",
                code: "doubles"
            }, {
                description: "Relay",
                code: "relay"
            }],
            records: [],
            loading: true,
            selected: "all"
        };
    },
    computed: {
        filteredRecords() {
            if (this.selected === "all")
                return this.records;

            return this.records.filter(singleTagFilter(this.selected));
        }
    },
    components: {
        PillFilterControl,
        WorldRecordsTable
    },
    created() {
        fetchMappedRecords()
            .then(records => {
                this.records = records;
                this.loading = false;
            });
    }
}
</script>